import { Bracket } from "./taxes"

// -----------------------------------------------
// AJ 2025 , inkomsten 2024
// -----------------------------------------------

/**
 * Brackets (aka "schrijven") for the personal income tax (aka "personen belasting").
 * 
 * Does not yet include dependents (aka "personen ten laste").
 */
export function personalIncomeBrackets() {
    return [
        new Bracket(10570, 0, 0),
        new Bracket(15820, 25, 0),
        new Bracket(27920, 40, 0),
        new Bracket(48320, 45, 0),
        new Bracket(Infinity, 50, 0)
    ]
}

/**
 * Exempt on personal income tax due to dependents.
 * (aka "vrijstelling op personen belasting door personen ten laste").
 */
export function personalIncomeTaxDependentsExempt(dependents: number): number {
    switch (dependents) {
        case 0: return 0
        case 1: return 1920
        case 2: return 4950
        case 3: return 11090
        case 4: return 17940
        default: return 17940 + (dependents - 4) * 6850
    }
}

/**
 * Social contribution for main activity.
 * (aka "sociale bijdragen voor hoofdberoep")
 * 
 * On a yearly (!) basis.
 */
export const socialContributionMainBrackets = [
    new Bracket(16861.46, 0, 890.51 * 4),
    new Bracket(72810.95, 5.125 * 4, 0),
    new Bracket(107300.30, 3.54 * 4, 0),
    new Bracket(Infinity, 0, 0)
]

/**
 * Social contribution for secondary activity.
 * (aka "sociale bijdragen voor bijberoep")
 */
export const socialContributionSecondaryBrackets = [
    new Bracket(1865.44, 0, 0),
    new Bracket(72810.95, 5.125 * 4, 0),
    new Bracket(107300.30, 3.54 * 4, 0),
    new Bracket(Infinity, 0, 0)
]

/**
 * Corporation tax (aka "vennootschapsbelasting")
 */
export const corporationBrackets = [
    new Bracket(Infinity, 25, 0)
]

/**
 * Minimal allowance the director must receive in order to qualify for
 * the reduced taxes for small corporations.
 */
export const smallCorporationMinimalAllowance = 45000;

/**
 * Reduced taxes for small corporations.
 * (aka "vennootschapsbelasting kleine onderneming")
 */
export const smallCorporationBrackets = [
    new Bracket(100000, 20, 0),
    new Bracket(Infinity, 25, 0)
]

/**
 * Withholding taxes (aka "bedrijfsvoorheffing")
 */
export const withHoldingBrackets = [
    new Bracket(Infinity, 15, 0)
]

/**
 * Administrative cost that comes with maintaining a corporation.
 * (Not really part of taxes.)
 */
export const administrationCost = 2400